import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { currentFeature } from "../../../../slice/features";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCamera,
  faCode,
  faDashboard,
  faEdit,
  faGrin,
  faHammer,
  faImage,
  faMobile,
  faPencil,
  faQuoteLeft,
  faUserEdit,
  faVideo,
  faVideoCamera,
  faVideoSlash,
} from "@fortawesome/free-solid-svg-icons";
import FeatureModule from "../../Features/FeatureModule";
import style from "./Features.module.css";

const Features = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  const handleClose = (handleClose) => {
    setShow(handleClose);
  };

  useEffect(() => {}, [dispatch]);
  return (
    <div className="m-2">
      {show ? <FeatureModule open={show} handleClose={handleClose} /> : null}
      <span className="custom-header">Features</span>
      <div className="d-flex flex-column">
        {/* first line */}
        <div className="d-flex flex-wrap  mb-2">
          <button
            className={`btn btn-success  ${style.FeatureButtons}`}
            onClick={(e) => {
              e.preventDefault();
              setShow(true);
              dispatch(currentFeature("Banner"));
            }}
          >
            <FontAwesomeIcon
              icon={faImage}
              style={{ color: "#EEBE36" }}
              className="ms-1 me-2"
            />
            Upload Banner
          </button>
        </div>

        <div className="d-flex flex-wrap  mb-2">
          <button
            className={`btn btn-success  ${style.FeatureButtons}`}
            onClick={(e) => {
              e.preventDefault();
              setShow(true);
              dispatch(currentFeature("Disclaimer"));
            }}
          >
            <FontAwesomeIcon
              style={{ color: "#9041F5" }}
              icon={faHammer}
              className="ms-1 me-2"
            />
            Disclaimer
          </button>
        </div>

        {/* second line */}
        <div className="d-flex flex-wrap  mb-2">
          <button
            className={`btn btn-success  ${style.FeatureButtons}`}
            onClick={(e) => {
              e.preventDefault();
              setShow(true);
              dispatch(currentFeature("DownloadApps"));
            }}
          >
            <FontAwesomeIcon
              icon={faMobile}
              style={{ color: "#62CAED" }}
              className="ms-1 me-2"
            />
            Download Apps
          </button>
        </div>

        <div className="d-flex flex-wrap  mb-2">
          <button
            className={`btn btn-success  ${style.FeatureButtons}`}
            onClick={(e) => {
              e.preventDefault();
              setShow(true);
              dispatch(currentFeature("Html"));
            }}
          >
            <FontAwesomeIcon
              style={{ color: "#FE9B00" }}
              icon={faCode}
              className="ms-1 me-2"
            />
            HTML
          </button>
        </div>

        {/* third line */}
        <div className="d-flex flex-wrap  mb-2 ">
          <button
            className={`btn btn-success  ${style.FeatureButtons}`}
            onClick={(e) => {
              e.preventDefault();
              setShow(true);
              dispatch(currentFeature("Quote"));
            }}
          >
            <FontAwesomeIcon
              icon={faQuoteLeft}
              style={{ color: "#8CC24B" }}
              className="ms-1 me-2"
            />
            Quote
          </button>
        </div>

        <div className="d-flex flex-wrap  mb-2">
          <button
            className={`btn btn-success  ${style.FeatureButtons}`}
            onClick={(e) => {
              e.preventDefault();
              setShow(true);
              dispatch(currentFeature("Video"));
            }}
          >
            <FontAwesomeIcon
              style={{ color: "#D71F1E" }}
              icon={faCamera}
              className="ms-1 me-2"
            />
            Video
          </button>
        </div>

        {/* Forth line */}
        <div className="d-flex flex-wrap   mb-2">
          <button
            className={`btn btn-success  ${style.FeatureButtons}`}
            onClick={(e) => {
              e.preventDefault();
              setShow(true);
              dispatch(currentFeature("VideoConference"));
            }}
          >
            <FontAwesomeIcon
              icon={faVideo}
              style={{ color: "#EEBE36" }}
              className="ms-1 me-2"
            />
            Video Conference
          </button>
        </div>
      </div>
    </div>
  );
};

export default Features;
